import React, { useState } from 'react';
import HowItWorks from '../UI/HowItsWorks';

const HowItWorksPlan = () => {
    

    const steps = [
        
        {
            number: 1,
            title: "Project Consultation",
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FPlanApproval%2FHOW_IT_WORKS_icon%2FConsultation_and_Project_Brief.png?alt=media&token=cb847512-f00e-4be0-b855-3b7f68492dde",
            description: ""
        },
        {
            number: 2,
            title: "Document Preparation & Submission",
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FPlanApproval%2FHOW_IT_WORKS_icon%2FDocument_Preparation_and_Submission.png?alt=media&token=70bf9456-9dc1-41f9-9125-d83eb4a79bab",
            
            description: ""
        },
        
        {
            number: 3,
            title: "Review & Compliance Check",
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FPlanApproval%2FHOW_IT_WORKS_icon%2FReview_and_Compliance_Check.png?alt=media&token=0615bd63-b9ad-49f3-a397-f39c3efe0bba",
            description: ""
        },
        {
            number: 4,
            title: "Follow-Up & Revisions",
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FPlanApproval%2FHOW_IT_WORKS_icon%2FFollow_Up_and_Revisions.png?alt=media&token=17aeab72-a58b-44b9-87e7-7470a5ffda50",
            
            description: ""
        },
        {
            number: 5,
            title: "Approval & Handover",
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FPlanApproval%2FHOW_IT_WORKS_icon%2FApproval_and_Handover.png?alt=media&token=7f117ff5-dbcb-4e8d-9fa7-897ac525b2ab",
            description: ""
        },
    ];


    return (
        <><HowItWorks steps={steps}/></>
    );
};

export default HowItWorksPlan;
